import { isProcessableCharge, getPaymentError } from '@/store/selectors'
import { useTypedSelector } from '@/store/hooks'

import PaymentDeclinedAlert from '@/components/Checkout/Alerts/PaymentDeclinedAlert'
import NotProcessableAlert from '@/components/Checkout/Alerts/NotProcessableAlert'

export const PurchaseModalErrors = () => {
  const error = useTypedSelector(getPaymentError)
  const isProcessable = useTypedSelector(isProcessableCharge)

  if (!isProcessable) {
    return <NotProcessableAlert />
  }

  if (error) {
    return <PaymentDeclinedAlert error={error} />
  }

  return null
}

export default PurchaseModalErrors
